export class FilterExportAnalyseFinanciere {
    dateDebut: Date;
    dateFin: Date;
    idsPointDeLivraison: number[];
    idsPointDeFacturation: number[];
    idsPrestation: number[];
    idsRegime: number[];
    idsRepas: number[];
}
